// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/core/num/v1/num.proto (package penumbra.core.num.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * The quantity of a particular Asset. Represented as a 128-bit unsigned integer,
 * split over two fields, `lo` and `hi`, representing the low- and high-order bytes
 * of the 128-bit value, respectively. Clients must assemble these bits in their
 * implementation into a `uint128` or comparable data structure, in order to model
 * the Amount accurately.
 *
 * @generated from message penumbra.core.num.v1.Amount
 */
export const Amount = proto3.makeMessageType(
  "penumbra.core.num.v1.Amount",
  () => [
    { no: 1, name: "lo", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "hi", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

